import { Badge } from './Badge';
import type { MeetingStatus } from '@/shared/api/meetings';

const LABEL: Record<MeetingStatus, string> = {
  DRAFT: '투표 전',
  VOTING: '투표중',
  CONFIRMED: '확정',
  ONGOING: '진행중',
  SETTLING: '정산중',
  CLOSED: '마감',
};

const TONE: Record<MeetingStatus, 'default' | 'primary' | 'success' | 'warning' | 'error'> = {
  DRAFT: 'default',
  VOTING: 'warning',
  CONFIRMED: 'primary',
  ONGOING: 'success',
  SETTLING: 'warning',
  CLOSED: 'default',
};

export function StatusBadge({ status }: { status: MeetingStatus }) {
  return <Badge tone={TONE[status]}>{LABEL[status]}</Badge>;
}
